import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const FooterBar = styled.div`
  height: 60px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 0 ${barnesTheme.spacing.pageMargin};
  border-top: none;
  margin-bottom: 16px;
  padding-bottom: 0;

  @media print {
    height: 60px !important;
    background: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 14px !important;
    padding: 0 ${barnesTheme.spacing.pageMargin} !important;
    border-top: none !important;
    margin-bottom: 16px !important;
  }
`

export const FooterWebsite = styled.span`
  color: ${barnesTheme.colors.text};
  font-family: ${barnesTheme.fonts.body};
  font-size: 14px;
  font-weight: ${barnesTheme.fontWeights.bold};
  border: none;

  @media print {
    color: ${barnesTheme.colors.text} !important;
    font-size: 14px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    border: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterSealWrapper = styled.div`
  display: flex;
  align-items: center;
  border: none;

  @media print {
    display: flex !important;
    align-items: center !important;
    border: none !important;
  }
`
